module.exports = __webpack_public_path__ + "static/neuehassunica-bold-81a336893441864f87c8d9bfbc1d1dc4.woff";